import {
  ADD_COMMENT,
  ADD_VA,
  CREATE_PROJECT,
  CREATE_TASK,
  DELETE_PROJECT,
  DELETE_TASK,
  FETCH_PROJECTS,
  FETCH_PROJECTS_ADMIN,
  FETCH_TASKS,
  FETCH_TASKS_ADMIN,
  NO_PROJECTS,
  NO_TASKS,
  NOTIFY_ADMIN,
  SLACK_MESSAGE_SENT,
  USER_FOUND,
  USER_NOT_FOUND,
} from '../../_actions/types';

const defaultState = {
  allProjects: {},
  activeProject: {},
  newTask: '',
  projectCount: 0,
  taskCount: 0,
  expanded: false,
  open: false,
  taskDialogOpen: false,
  task: '',
  project: '',
  newDescription: '',
  newTitle: '',
  newVA:'',
  newComment: '',
  allTasks: {},
};

export default function (state = defaultState, action) {
  switch (action.type) {

    case ADD_COMMENT:
      return { ...state }
    case ADD_VA:
      return { ...state, newVA: ''}
    case CREATE_TASK:
      return { ...state, newTask: '' };
    case DELETE_PROJECT:
      return { ...state };
    case DELETE_TASK:
      return { ...state };
    case FETCH_PROJECTS:
      return { ...state, allProjects: action.payload, projectCount: action.projectCount };
    case FETCH_PROJECTS_ADMIN:
      return { ...state, allProjects: action.payload, projectCount: action.projectCount };
    case FETCH_TASKS:
      return { ...state, allTasks: action.payload, count: action.count}
    case FETCH_TASKS_ADMIN:
      return { ...state, allTasks: action.payload };
    case NO_PROJECTS:
      return { ...state, allProjects: {}, activeProject: {}, projectCount: 0 };
    case NO_TASKS:
      return { ...state, taskCount: 0};
    case NOTIFY_ADMIN:
      return {...state}
    case CREATE_PROJECT:
      return { ...state, newBuyer: '', newAddress: '', newCity: '', newState: '', newZip: '', }
    case SLACK_MESSAGE_SENT:
      return { ...state, }
    case USER_FOUND:
      return { ...state}
    case USER_NOT_FOUND:
      return { ...state}
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/components/project/project_reducer.js